import React from "react";
import { AccountsPage } from "./AccountsPage";
import { useAccounts } from "./useAccounts";

function Accounts() {
  return <AccountsPage {...useAccounts()} />;
}

export default Accounts;
